module.exports = __webpack_public_path__ + "static/media/hut-image1.250e9053.png";